import { ActivityPacing } from '@showbie-socrative/socrative-utils';

import { RoomTypes } from '~analytics/types';

import { sendLaunchQuizEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchQuizEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-quiz';
  protected amplitudeEventFunction = sendLaunchQuizEvent;

  constructor(settings: any, isRosteredRoom: boolean) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      let deliveryMethod = 'instant_feedback';

      if (settings.pacing === ActivityPacing.Teacher)
        deliveryMethod = 'teacher_paced';
      if (settings.allow_student_nav) deliveryMethod = 'open_navigation';

      this.eventData = {
        room_type: roomType,
        delivery_method: deliveryMethod,
        activity_require_names: settings.require_names,
        activity_shuffle_questions: settings.random_questions,
        activity_shuffle_answers: settings.random_answers,
        activity_show_question_feedback: settings.show_feedback,
        activity_show_final_score: settings.show_results,
        activity_one_attempt: settings.one_attempt,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
